import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { InputGroup, InputGroupAddon, InputGroupText, Input } from "reactstrap";

const ShowAttachmentComponent = props => {
    const documentTypes = ["doc", "pdf"];
    const imageTypes = ["gif", "jpg", "jpeg", "svg"];
    const [isImage, setIsImage] = useState(true);

    const openUrl = () => {
        window.open(props.url, "_blank");
    }

    useEffect(() => {
        const extension = props.url ? props.url.split(".").pop() : '';
        console.log("Match here: ", props.url, extension, documentTypes.indexOf(extension));
        if (documentTypes.indexOf(extension) != -1) {
            console.log("Hey here: ", documentTypes.indexOf(extension));
            setIsImage(false);
        }
    }, [props.url]);
    return (
        <Fragment>
            <div onClick={openUrl} className={"attachment-component cursor-pointer" + (props.className ? props.className : '')}>
                {
                    isImage ? (
                        <div className="image-container">
                            <div alt="attached-img" className="img" style={{ backgroundImage: `url(${props.url})` }}></div>
                        </div>
                    ) : (
                        <div className="document-container">
                                <p className="p-0 m-0 text-center">Attached Document</p>
                        </div>
                    )
                }
            </div>
        </Fragment>
    );
};

export default ShowAttachmentComponent;

ShowAttachmentComponent.defaultProps = {
    className: "",
    url: ""
};

ShowAttachmentComponent.propTypes = {
    className: PropTypes.string,
    url: PropTypes.string
};
